<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        {{ currentUser.name }} - "{{ currentUser.display_name }}"
      </div>
    </template>
    <div class="d-flex flex-column">
      <ManageSection />
      <UserSection />
      <RequestsSection :user_id="user_id" style="overflow-x: hidden;"/>
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import ManageSection from './sections/Manage'
import RequestsSection from './sections/Requests'
import UserSection from './sections/User'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserDetailView',

  components: { ContentPage, ManageSection, RequestsSection, UserSection },

  props: ['user_id'],

  computed: {
    ...mapGetters('users', ['currentUser']),
  },
  

  methods: {
    ...mapActions('users', ['loadCurrentUser']),
  },

  created() {
    this.loadCurrentUser({ user_id: this.user_id })
  }
}
</script>
